export default "__VITE_ASSET__DjbFdfoT__"